import React, { Component } from 'react';
import axios from 'axios';
import {API_URL} from '../../constants';
import { Link } from 'react-router-dom';
import Moment from 'moment';

export default class Principal extends Component {

  

  constructor(props){
    super(props);

    this.state = {
      resource: [],
      response: [],
      error: [],
      key: 0,
      clave: this.props.clave,
      clase: this.props.clase,
      security: JSON.parse(localStorage.getItem('userBulletin'))
    }
  }

  componentDidMount(){

    var code = 'NOTI';
    var key = this.props.clave;
    var url = `${API_URL}BulletinResourceUX/${key}/${code}`;
    axios.get(url).then(response => response.data)
    .then((data) => {
      
      // console.log(data.result);

      var arr = data.result.filter(item => item.cRec_Id===7);
      this.setState({ resource: arr });
    }).catch(error => {
    });
  }

  render(){
    Moment.updateLocale('en', {
      months : [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
        "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
      ]
    });
    Moment.updateLocale('en', {
      weekdays : [
        "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
      ]
    });

    return (

      
      this.state.resource.length>0 ? (
        <div className="boletin__section">
          <div className="boletin__section">
            <div className="row last-news__row">
              <div className={"last-news__main col-sm-6 last-news__main--" + this.props.clase }>
                <div id="carouselLastNewsIndicators" className="carousel slide" data-ride="carousel" data-touch="true">
                  <ol className="carousel-indicators">
                    {this.state.resource.map((resource, index) => (
                      <li key={resource.nRecursoCodigo} data-target="#carouselLastNewsIndicators" data-slide-to={index} className={index==0?"active":""}></li>
                    ))} 
                  </ol>
                  <div className="carousel-inner" >
                    {this.state.resource.map((resource, index) => (
                      <div key={resource.nRecursoCodigo} className={index==0?"carousel-item active":"carousel-item"}>
                        <Link to={ '/' + this.props.clave + '/' + resource.nRecursoCodigo } className="new-opportunity__more-info-link">
                        <p className={"last-news__category last-news__category--" + this.props.clase}>TENDENCIAS</p>
                        <p className="last-news__title"> {resource.sTituloRecurso}</p>
                        <p className="last-news__extract">
                          {resource.sResumenRecurso}
                        </p>
                        <p className="last-news__more-info">
                          <span className="last-news__more-info-date">{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</span>
                          
                              <span className="last-news__more-info-arrow">
                                  <i className="fas fa-chevron-right"></i>
                              </span>
                        </p>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ):(
        <div></div>
      )
    )
  }
}
